// eslint-disable-next-line jira/restricted/graphql-tag
import gql from 'graphql-tag';
import { PROJECT_WITHOUT_CLASSIFICATION } from '../../../../common/graphql/fragments.tsx';

export const PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION = gql`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${PROJECT_WITHOUT_CLASSIFICATION}
`;
